var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inline-block px-4 py-1 bg-red-600 bg-opacity-25 border border-solid border-red-600 transform skew-x-20"},[_c('p',{staticClass:"text-sm transform -skew-x-20"},[_c('span',{staticClass:"uppercase text-red-600 mr-2 font-semibold"},[_vm._v("Error")]),_vm._v(" "+_vm._s(_vm.error)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }